declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    noSub?: boolean;
    showInMenu?: boolean;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from "../views/login.vue";
import home from "../views/home/home.vue";
import main from "../views/main.vue";

import fullRouter from "./fullfunction";
import printer from "./printer";

export const locking = {
  path: "/locking",
  name: "locking",
  component: () =>
    import("../components/lockscreen/components/locking-page.vue"),
};
export const changePass = {
  path: "/change-password",
  name: "changePassword",
  meta: {
    title: "ChangeUserPassword",
  },
  component: () => import("../views/setting/user/login-change-password.vue"),
};
export const loginRouter: Router = {
  path: "/",
  name: "login",
  meta: {
    title: "LogIn",
  },
  component: () => import("../views/login.vue"),
};

export const error403Router: Router = {
  path: "/error-403",
  name: "error-403",
  meta: {
    title: "403",
  },
  component: () => import("../views/error403.vue"),
};

export const otherRouters: Router = {
  path: "/main",
  name: "main",
  permission: "",
  meta: { title: "ManageMenu" },
  component: main,
  children: [
    {
      path: "home",
      meta: { title: "HomePage" },
      name: "home",
      component: () => import("../views/home/home.vue"),
    },
  ],
};

export const appRouters: Array<Router> = [...fullRouter];

export const appPrinters: Array<Router> = [...printer];

export const routers = [
  loginRouter,
  error403Router,
  locking,
  changePass,
  ...appRouters,
  otherRouters,
  ...appPrinters,
];
